<div class="app-container">
  <public-header *nativeAppHidden [providerPracticeState]="providerShareableProfile?.practice_state?.abbrev"></public-header>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isValid; else notFound">
      <main class="main-content" (scroll)="areActionsScrolledIntoView()">
        <landing-page-header
          *ngIf="providerShareableProfile"
          [providerShareableProfile]="providerShareableProfile"
          [paramsShareCode]="paramsShareCode"
          [paramsName]="paramsName"
          [queryParamMap]="queryParamMap"
          [requestSessionQueryParams]="requestSessionQueryParams"
          [topSpecialties]="topSpecialties"
          (requestASessionClicked)="onRequestSessionButtonClicked()"
        ></landing-page-header>
        <div #actions class="actions">
          <iris-card  
            *ngIf="isCalendarLoading"
            class="actions-loader-container"
            [elevation]="1"
          >
            <div class="actions-loader loading-spinner"></div>
          </iris-card>
          <iris-card
            *ngIf="(showProviderCalendar$ | async) && !isCalendarLoading && !(isScheduled)"
            id="public-provider-calendar"
            class="provider-calendar-card"
            data-test="calendar-form"
            [elevation]="1"
          >
            <public-provider-calendar
              [appointmentSlots]="appointmentSlots$ | async"
              (appointmentSlotsProcessed)="onCalendarInit($event)"
              (requestASessionClicked)="onRequestSessionButtonClicked($event)"
              [providerId]="providerShareableProfile?.id"
              [providerPrimaryAddress]="providerPrimaryAddress"
              [providerSessionTypesOffered]="providerShareableProfile?.session_types_offered"
              [providerTimeZone]="providerShareableProfile?.time_zone"
              [soonestAvailableDate]="soonestAvailableDate$ | async"
            ></public-provider-calendar>
          </iris-card>
          <connect-card
            id="connect-card"
            *ngIf="!(showProviderCalendar$ | async) && !isCalendarLoading"
            [accepting]="providerShareableProfile?.accepting_clients"
            [firstName]="providerShareableProfile?.display_first_name"
            [ctaButtonText]="(pslRedesignFf$ | async)?.ctaButtonText"
            [paramsShareCode]="paramsShareCode"
            [paramsName]="paramsName"
            [requestSessionQueryParams]="requestSessionQueryParams"
            [soonestAvailableDate]="soonestAvailableDate$ | async"
            (requestASessionClicked)="onRequestSessionButtonClicked()"
          ></connect-card> 
          <!-- Comment in to show for testing purposes -->

          <support-phone-number-card></support-phone-number-card>
        </div>
    
        <provider-details
          [providerShareableProfile]="providerShareableProfile"
          [topSpecialties]="topSpecialties"
        >
        </provider-details>

        <browse-therapists-card
          *nativeAppHidden
          [currentStateAbbrev]="providerShareableProfile?.practice_state?.abbrev">
        </browse-therapists-card>

        <!-- Footer is contained within main to have body + footer be scrollable together -->
        <footer >
          <public-footer 
            *nativeAppHidden
            [matchflowBaseUrl]="therapyMatchFlowUrl">
          </public-footer>
        </footer>
      </main>

      <div
        class="mobile-bottom-drawer"
        [ngClass]="{ 'hidden': isCalendarScrolledIntoView }"
        data-test="mobile-bottom-drawer"
      >
        <ng-container *ngTemplateOutlet="(isScheduled) ? scheduledSessionTemplate : bookSessionTemplate">
        </ng-container>
        <ng-template #scheduledSessionTemplate>
          <div class="success-container">
            <iris-icon name="check_circle" class="success-icon"></iris-icon>
            <span class="success-text">Session scheduled!</span>
          </div>
        </ng-template>

        <ng-template #bookSessionTemplate>
          <iris-button-container>
            <iris-button
              (click)="onMobileDrawerButtonClicked()"
              class="request-session-button"
              data-test="book-session-mobile"
            >
              Book a session
            </iris-button>
          </iris-button-container>
        </ng-template>
      
        <span class="support-phone-number">
          Need support? Call <a href="tel:{{ supportPhoneNumberLink }}">{{supportPhoneNumberDisplay}}</a>
        </span>
      </div>
    </ng-container>
  </ng-container>
</div>
  
<ng-template #notFound>
  <div class="page-not-found-container">
    <page-not-found [redirectUrl]="therapyMatchFlowUrl"></page-not-found>
  </div>
</ng-template>

<ng-template #loading>
  <div class="full-page-loader loading-spinner"></div>
</ng-template>

